waitForJquery(function() {
  return;
  moment.tz.add('America/Los_Angeles|PST PDT|80 70|0101|1Lzm0 1zb0 Op0');
  var cc_t, cc_cartNotBusy, CriquetCart = {
    init: function() {
      // console.log(12345);
      cc_cartNotBusy = true;
      this.initCartUI();
      this.initAddToCartForm();
    },
    initCartUI: function() {
      $('#cart-icon-bubble').on('click', function(e) {
        // console.log('$(\'#cart-icon-bubble\').on(\'click\')');
        e.preventDefault();

        CriquetCart.updateCartBadge();
      });
      $('.ajax-cart').on('click', function(e) {
        // console.log('$(\'.ajax-cart\').on(\'click\')');
        var hotSpot = $('.btn-close-cart, .ajax-cart, .continue');
        if (hotSpot.is(e.target)) {
          e.preventDefault();
          CriquetCart.closeAjaxCart();
        }
      });
      if ('ontouchstart' in window) {
        $('.ajax-cart').on('touchend', function(e) {
          var hotSpot = $('.ajax-cart');
          if (hotSpot.is(e.target)) {
            CriquetCart.closeAjaxCart();
          }
        });
      }
      if ('ontouchstart' in window) {
        $('.cart-form .cart-item-qty').on('blur', function() {
          var thisRow = $(this).closest('.cart-item');
          var itemId = $(this).data('productId');
          var qty = $(this).val();
          CriquetCart.updateCart(itemId, qty);
        });
      } else {
        $('.cart-form .cart-item-qty').on('input', function() {
          var thisRow = $(this).closest('.cart-item');
          var itemId = $(this).data('productId');
          var qty = $(this).val();
          CriquetCart.updateCart(itemId, qty);
        });
      }
      $('.cart-item__remove').on('click', function(e) {
        e.preventDefault();

        if (typeof window.PlusCart != "undefined") {
          var plusGiftProductRemoved = $(this).closest("[data-plus-handle]").data('plus-handle');
          if (plusGiftProductRemoved == window.PlusCart.gift_product_handle)
            $('#plusGiftContainer #plusGiftBox').prop('checked', false);
          $('#plusGiftContainer').html(window.PlusCart.plusHTMLContainer).show();
        }
        if (cc_cartNotBusy) {
          var thisItem = $(this).closest('.cart-item');
          var itemId = $('.cart-item-qty', thisItem).data('productId');
          var qty = 0;
          thisItem.remove();
          CriquetCart.updateCart(itemId, qty);
        }
        setTimeout(function() {
          $('html').trigger('cartClassChanged');
        }, 3000);
      });
    },
    initAddToCartForm: function() {
      $('form[action="/cart/add"]').on('submit', function(e) {

        e.preventDefault();
        if ($('.quick-add').length) {
          $(this).closest('.quick-add').addClass('quick-adding-to-cart');
        } else {
          $('.btn-addtocart', this).addClass('disabled').prop('disabled', true).text('Adding...');
        }
        var prodId = $(this).find('[name="id"]').val();
        var qty = $(this).find('[name="quantity"]').val();
        CriquetCart.addToCart(prodId, qty);
      });
    },
    addToCart: function(id, qty, properties = '') {
      properties = { '_freeGift': properties }
      $.post('/cart/add.js', { quantity: qty, id: id, properties: properties }, function() {
        CriquetCart.updateCartBadge();
        //window._tfa.push({notify: 'event', name: 'add_to_cart', id: 1021484});
      }, 'json').fail(function(error) {
        CriquetCart.resetButtons();
        //  alert("Ooops! " + error.responseJSON.description);
      });
    },
    updateCart: function(id, qty) {
      cc_cartNotBusy = false;
      clearTimeout(cc_t);
      cc_t = setTimeout(function() {
        var dataString = 'updates[' + id + ']=' + qty;
        $.post('/cart/update.js', dataString, CriquetCart.updateCartBadge, 'json').fail(function(error) {
          CriquetCart.resetButtons();
          //    alert("Ooops! " + error.responseJSON.description);
        });
      }, 150);
    },
    updateCartAttribute: function(key, val) {
      var dataString = 'attributes[' + key + ']=' + val;
      $.post('/cart/update.js', dataString, null, 'json').fail(function(error) {
        //   alert("Ooops! " + error.responseJSON.description);
      });
    },
    updateCartBadge: function() {
      var $freeShippingFeedback = $("#free-shipping-feedback")
      $freeShippingFeedback.text('').hide();
      $.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'jsonp',
        success: function(data) {
          var items = data['items'];

          var item_count = data['item_count'];

          var cart_total = data['total_price'] / 100;
          var cart_original_total = data['original_total_price'] / 100;
          cart_total = cart_total.toFixed(2)
          cart_total = cart_total.toString();
          cart_total = cart_total.replace('.00', '');
          cart_original_total = cart_original_total.toFixed(2)
          cart_original_total = cart_original_total.toString();
          cart_original_total = cart_original_total.replace('.00', '');
          if ($('.template-cart').length && cart_total < 1) {
            document.location.href = '/cart';
          } else {
            if (items.length) {
              var freeShippingMsg = "";
              var firstPromoStartDateTime = moment.tz("2018-12-09 00:00", "America/Los_Angeles").format();
              var firstPromoEndDateTime = moment.tz("2018-12-16 23:59", "America/Los_Angeles").format();
              var secondPromoStartDateTime = moment.tz("2018-12-17 00:00", "America/Los_Angeles").format();
              var secondPromoEndDateTime = moment.tz("2018-12-20 11:00", "America/Los_Angeles").format();
              var thirdPromoStartDateTime = moment.tz("2018-12-20 00:00", "America/Los_Angeles").format();
              var thirdPromoEndDateTime = moment.tz("2018-12-21 11:00", "America/Los_Angeles").format();
              var fourthPromoStartDateTime = moment.tz("2019-12-13 00:00", "America/Los_Angeles").format();
              var fourthPromoEndDateTime = moment.tz("2021-11-30 23:59", "America/Los_Angeles").format();
              var currentDateTime = moment();
              var currentPDDateTime = currentDateTime.tz('America/Los_Angeles').format();
              if (!currentDateTime.isBetween(fourthPromoStartDateTime, fourthPromoEndDateTime)) {
                if ($freeShippingFeedback.length && $('[data-free-shipping-cart-total]').length && !$('[data-vip-customer]').length) {

                  var freeShippingCartTotal = $('[data-free-shipping-cart-total]').attr('data-free-shipping-cart-total');
                  console.log(parseInt(freeShippingCartTotal));
                  if (parseInt(cart_total) < parseInt(freeShippingCartTotal)) {
                    console.log(cart_total, freeShippingCartTotal);
                    freeShippingMsg = "Add another shirt to get free shipping.";
                  } else if (parseInt(cart_total) > parseInt(freeShippingCartTotal)) {
                    console.log(freeShippingCartTotal, cart_total, item_count);
                    freeShippingMsg = "You qualify for free shipping!";
                  }
                }
              }
              if (currentDateTime.isBetween(firstPromoStartDateTime, firstPromoEndDateTime)) {
                freeShippingMsg = "Free standard shipping on all orders";
              }
              if (currentDateTime.isBetween(secondPromoStartDateTime, secondPromoEndDateTime)) {
                freeShippingMsg = cart_total < 149 ? "Spend +$149 for free 2 Day shipping" : "You qualify for free 2 Day shipping!";
              }
              if (currentDateTime.isBetween(thirdPromoStartDateTime, thirdPromoEndDateTime)) {
                freeShippingMsg = cart_total < 199 ? "Spend +$199 for free overnight shipping." : "You qualify for free overnight shipping!";
              }
              if (currentDateTime.isBetween(fourthPromoStartDateTime, fourthPromoEndDateTime)) {
                var amountLeft = 199 - cart_total;
                freeShippingMsg = cart_total < 199 ? "You're $" + amountLeft + " away from the free High Life Hat" : "Congrats! Your free hat has been added to your cart!";
              }
              var addUpMsg = "";
              if (freeShippingMsg.length) {
                $freeShippingFeedback.text(freeShippingMsg).show();
              } else {
                $freeShippingFeedback.text('').hide();
              }
            }
            $('#cart-total').text(item_count);
            $('#cart-subtotal').text('$' + cart_total);
            if (!$('.template-cart').length) {
              CriquetCart.updateAjaxCart(items, cart_total);
            }
            CriquetCart.successMessage();
          }
          window.ShopifyCart.totalPrice = cart_total;
          window.ShopifyCart.originalTotalPrice = cart_original_total;
        },
        error: function(result) {}
      });
    },
    updateAjaxCart: function(items, cart_total) {
      $('.ajax-cart .cart-item, .ajax-cart .cart-empty').remove();
      if (items.length > 0) {
        var count = 1;
        var freeItemInCart = false;
        $('#plusCartSidebar').removeClass("plus-hidden");
        items.forEach(function(item) {
          var prodImg = item.image.replace(/(\.[^.]*)$/, "_150x150_crop_center$1").replace('http:', '');
          var prodTtl = item.product_title;
          var prodType = '';
          var prodOption = '';
          var ttlArray = prodTtl.split(' - ');
          var forGiftTitle = ttlArray;
          if (!freeItemInCart) {
            $('.freeProductJson').each(function() {
              var _product = JSON.parse($(this).html());
              if (_product.id == item.product_id) {
                freeItemInCart = true;
              }
            });
          }
          if (ttlArray.length > 1) {
            ttlArray.shift();
            prodTtl = ttlArray.join('');
          }

          prodType = '<h2 >' + item.product_type + '</h2>';
          if (item.product_type !== item.product_title) {
            if (!jQuery.isEmptyObject(item['properties'])) {

              if (item['properties']['_freeGift']) {

                prodType = '<h2 >Free Gift With Purchase</h2>';
              }
            }
          }
          if (item.variant_title != null) {
            var label = 'Size'
            if (item.gift_card) {
              label = 'Value';
            }
            var variantTtl = item.variant_title.toUpperCase();
            prodOption = '<p>' + label + ': ' + variantTtl + '</p>';
          }
          var prodPrice = item.final_price / 100;
          prodPrice = prodPrice.toFixed(2)
          prodPrice = prodPrice.toString();
          prodPrice = prodPrice.replace('.00', '');
          var plusGiftProduct = '';
          if (typeof window.PlusCart != "undefined" && window.PlusCart.gift_product_handle == item.handle) {
            plusGiftProduct = 'data-plus-handle="' + item.handle + '"';
          }
          var freeProductClass = '';
          // console.log(jQuery.isEmptyObject(item['properties']));
          var itemUrl = item.url
          if (!jQuery.isEmptyObject(item['properties'])) {
            if (item['properties']['_freeGift']) {
              freeProductClass = 'hide';
              itemUrl = 'javascript:void(0)'
            }
          }
          var itemMarkup = '<div class="cart-item ' + plusGiftProduct + '">\
                    <a href="/cart/change?line=' + count + '&amp;quantity=0" class="cart-item__remove ' + freeProductClass + '">&times;</a>\
                    <a class="cart-item__image" href="' + itemUrl + '">\
                        <img loading="lazy" class="img-responsive" src="' + prodImg + '"  alt="' + item.title + '" />\
                    </a>\
                    <div class="cart-item__content">\
                        <a href="' + itemUrl + '">\
                            ' + prodType + '\
                            <div class="h1">' + prodTtl + '</div>\
                            ' + prodOption + '\
                        </a>\
                        <div class="cart-item__qty-price">\
                            <div class="qty ">\
                                <input id="updates_' + item.id + '" class="cart-item-qty  ' + freeProductClass + '" data-product-id="' + item.id + '" type="number" name="updates[]" value="' + item.quantity + '" min="1">\
                            </div>\
                            <div class="price">$' + prodPrice + '</div>\
                        </div>\
                    </div>\
                </div>';
          $('.ajax-cart .cart-grid').append(itemMarkup);
          count += 1;
        });
        var freeHatMessageMarkup = "";
        // console.log("cart_total", cart_total, !freeItemInCart, true === $(".ajax-cart").data('free-hats'));
        if (!freeItemInCart && true === $(".ajax-cart").data('free-hats')) {
          // console.log(cart_total)
          if (cart_total < 199) {
            freeHatMessageMarkup = `
                        <div class="cart-item free-hat-item">
                            <strong>Spend $199+ get a free hat! ($30 value)</strong>
                        </div>`;
          } else {
            freeHatMessageMarkup = `
                    <div class="cart-item free-hat-item">
                        <strong>Select your free hat!</strong>
                    </div>`;
            $('.freeProductJson').each(function() {
              var product = JSON.parse($(this).html());
              // console.log('free product', product);
              freeHatMessageMarkup += `
                        <div class="cart-item free-item" data-variant-id="${product.variants[0].id}">
                            <a class="cart-item__image" href="/products/${product.handle}">
                                <img loading="lazy" class="img-responsive" src="${product.images[0]}" alt="${product.title}">
                            </a>
                            <div class="cart-item__content">
                                <a href="/products/${product.handle}">
                                    <div class="h1">${product.title}</div>
                                    <p><u>Select to Add »</u></p>
                                </a>
                                <div class="cart-item__qty-price">
                                    <!--<div class="qty">
                                        <input class="cart-item-qty" data-product-id="${product.id}" name="quantity" value="0" min="0" type="number">
                                    </div>-->
                                </div>
                            </div>
                        </div>`;
            });
          }
        }
        $('.ajax-cart .cart-grid').append(freeHatMessageMarkup);
        $('#cart-icon-bubble').off('click');
        $('.ajax-cart').off('click');
        $('.ajax-cart').off('touchend');
        $('.cart-form .cart-item-qty').off('input');
        $('.cart-item__remove').off('click');
        CriquetCart.initCartUI();
      } else {
        if ($('div#plusCartSidebar').hasClass('plus-hidden') == false) $('div#plusCartSidebar').addClass('plus-hidden');
        var emptyMarkup = '<div class="cart-empty">\
                    <p class="supra">Looks like your<br>\
                    cart is empty :(</p>\
                </div>';
        $('.ajax-cart .cart-grid').html(emptyMarkup);
      }
      CriquetCart.openAjaxCart();
    },
    toggleAjaxCart: function() {
      $.scrollLock();
      $('html').toggleClass('ajax-cart-is-open').trigger('cartClassChanged');
    },
    openAjaxCart: function() {
      $.scrollLock(true);
      $('html').addClass('ajax-cart-is-open').trigger('cartClassChanged');
    },
    closeAjaxCart: function() {
      $.scrollLock(false);
      $('html').removeClass('ajax-cart-is-open');
    },
    clearCart: function(redirectUrl) {
      if (typeof redirectUrl === 'undefined') {
        redirectUrl = '/cart';
      }
      var params = {
        type: 'POST',
        url: '/cart/clear.js',
        success: function(line_item) {
          document.location.href = redirectUrl;
        },
        error: function(result) {
          document.location.href = redirectUrl;
        }
      };
      $.ajax(params);
    },
    successMessage: function() {
      $('.btn-addtocart').text('thank you!');
      $('.quick-adding-to-cart').addClass('quick-thank-you').removeClass('quick-adding-to-cart');
      var timer = setTimeout(function() {
        CriquetCart.resetButtons();
      }, 1000);
    },
    resetButtons: function() {
      $('.btn-addtocart').removeClass('disabled').prop('disabled', false).text('Add To Cart');
      $('.quick-thank-you').removeClass('quick-thank-you');
      cc_cartNotBusy = true;
    },
  };
  CriquetCart.init();
  $.scrollLock = (function scrollLockClosure() {
    'use strict';
    var $html = $('html'),
      locked = false,
      prevScroll = { scrollLeft: $(window).scrollLeft(), scrollTop: $(window).scrollTop() },
      prevStyles = {},
      lockStyles = { 'overflow-y': 'scroll', 'position': 'fixed', 'width': '100%' };
    saveStyles();

    function saveStyles() {
      var styleAttr = $html.attr('style'),
        styleStrs = [],
        styleHash = {};
      if (styleAttr && styleAttr.length) {
        styleStrs = styleAttr.split(/;\s/);
        // console.log(styleStrs);
        $.each(styleStrs, function serializeStyleProp(index, styleString) {
          if (!styleString) {
            return;
          }
          // console.log(styleString);
          var keyValue = styleString.split(/\s:\s/);
          if (keyValue.length < 2) {
            return;
          }
          styleHash[keyValue[0]] = keyValue[1];
        });
      }
      $.extend(prevStyles, styleHash);
    }

    // function lock() {
    //   var appliedLock = {};
    //   if (locked) {
    //     return;
    //   }
    //   prevScroll = { scrollLeft: $(window).scrollLeft(), scrollTop: $(window).scrollTop() };
    //   saveStyles();
    //   $.extend(appliedLock, lockStyles, { 'left': -prevScroll.scrollLeft + 'px', 'top': -prevScroll.scrollTop + 'px' });
    //   $html.css(appliedLock);
    //   $(window).scrollLeft(0).scrollTop(0);
    //   locked = true;
    // }

    // function unlock() {
    //   if (!locked) {
    //     return;
    //   }
    //   $html.attr('style', $('<x>').css(prevStyles).attr('style') || '');
    //   $(window).scrollLeft(prevScroll.scrollLeft).scrollTop(prevScroll.scrollTop);
    //   locked = false;
    // }

    var bdyCls = 'locked';

    function lock() {
      var lastTop = $(window).scrollTop();
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').addClass(bdyCls).css({ top: -lastTop });
      if (isIOS) {
        var hght = window.innerHeight - 1;
        console.log(hght)
        console.log(hght + 1)
        $('body').css({ height: hght });

      }
      locked = true;

    }

    function unlock(el) {
      var lastTop = Math.abs(parseInt($('body').css('top')));
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').css({ top: 0 }).removeClass(bdyCls);
      window.scrollTo(0, lastTop);
      if (isIOS) {
        $('body')[0].style.removeProperty('height');
      }
      locked = false;

    }

    return function scrollLock(on) {
      if (arguments.length) {
        if (on) {
          lock();
        } else {
          unlock();
        }
      } else {
        if (locked) {
          unlock();
        } else {
          lock();
        }
      }
    };
  }());

  $(document).ready(function() {
    $(document).on('input', '#plusCartInstructions', function() {
      $('#CartSpecialInstructions').toggleClass('plus-hidden');
    })
    $(document).on('click', 'button.button.skbx-price-store.sky-show', function(e) {
      e.preventDefault();
      var plusNoteVal = $('#CartSpecialInstructions').val();
      plusNoteVal = plusNoteVal.replace(/(\r\n|\n|\r)/gm, " ");
      if (plusNoteVal != undefined) {
        var url = this.href;
        var plusDataString = '';
        if ($('#plusCartInstructions').is(":checked")) {
          if (~plusNoteVal.indexOf("Gift Message:")) {
            plusDataString = plusNoteVal;
          } else {
            plusDataString = 'Gift Message: ' + plusNoteVal;
          }
        }
        var data = { "note": plusDataString };

        $.post('/cart/update.js', data, null, 'json').done(function(data) {
          window.location = '/checkout';
        });
      }
    });
  });
  $(document).on('change', '#plusGiftBox', function() {
    var plusVariantID = $(this).val();
    if (plusVariantID != "") {
      CriquetCart.updateCart(plusVariantID, 1);
      if ($('.template--cart').length >= 1) {
        setTimeout(function() {
          location.reload();
        }, 5000)
      }
      $('#plusGiftContainer').hide();
    }
  });

})